module.exports = __webpack_public_path__ + "static/materiel_informatique-8590becb9c470f99030b7fcbbbca991d.png";